import React, { Component } from "react";
import gql from "graphql-tag";
import { Switch, Route, Redirect } from "react-router";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import Loadable from "react-loadable";
import Box from "grommet/components/Box";
//Component

import { createAuth0Client } from "@auth0/auth0-spa-js";

import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import WatchedMutationLink from "apollo-link-watched-mutation";
import AppSettings from "./utils/appSettings";
import { watchedMutations } from "./apollo";
//Actions
import { graphqlError, networkError, resetNetworkError, resetGraphqlError } from "./store/actions/error";

import "./style/main.scss";

import { DefaultLoader } from "./components/common/DefaultLoader";
import { AUTH_CONFIG_LOCAL, AUTH_CONFIG_DEV, AUTH_CONFIG_PRODUCTION } from "./auth/auth0-variables";

// signinOrCreateAccount({ accessToken, idToken, expiresAt }) {
//   console.log(this.apolloClient);
//   console.log("idToken", idToken);
//   this.apolloClient
//     .mutate({
//       mutation: AUTHENTICATE,
//       variables: { idToken }
//     })
//     .catch(err => console.log("Sign in or create account error: ", err));
// }

let AUTH_CONFIG;

switch (process.env.REACT_APP_STAGE) {
  case "production":
    AUTH_CONFIG = AUTH_CONFIG_PRODUCTION;
    break;
  case "dev":
    AUTH_CONFIG = AUTH_CONFIG_DEV;
    break;
  default:
    AUTH_CONFIG = AUTH_CONFIG_LOCAL;
    break;
}

const AUTHENTICATE = gql`
  mutation signUp($idToken: String!) {
    signUp(idToken: $idToken) {
      id
      email
      emailVerified
    }
  }
`;
export const httpLink = new HttpLink({ uri: AppSettings.apiUrl });
export const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = window.localStorage.getItem("access_token");
  if(!token) {
    return {
      headers
    }
  } else {
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : ``,
      },
    };
  }
});

const Loading = () => (
  <Box full align="center" justify="center">
    Chargement de l'application
    <DefaultLoader />
  </Box>
);

const Container = Loadable({
  loader: () => import("./screen/Container"),
  loading: Loading,
});

const PrintComputation = Loadable({
  loader: () => import("./screen/print/PrintComputation"),
  loading: Loading,
});

const PrintCount = Loadable({
  loader: () => import("./screen/print/PrintCount"),
  loading: Loading,
});

const PrintSuperCount = Loadable({
  loader: () => import("./screen/print/PrintSuperCount"),
  loading: Loading,
});

const PrintEncodedComputation = Loadable({
  loader: () => import("./screen/print/PrintEncodedComputation"),
  loading: Loading,
});

const ShareComputation = Loadable({
  loader: () => import("./screen/share/ShareComputation"),
  loading: Loading,
});

const ShareEncodedComputation = Loadable({
  loader: () => import("./screen/share/ShareEncodedComputation"),
  loading: Loading,
});

const ShareCount = Loadable({
  loader: () => import("./screen/share/ShareCount"),
  loading: Loading,
});

class App extends Component {
  cache = new InMemoryCache();
  WatchedMutationLink = new WatchedMutationLink(this.cache, watchedMutations);
  notifyError = onError(({ response, graphQLErrors, networkError }) => {
    console.log("Apollo Error Catched in Link", response, graphQLErrors, networkError);
    if (networkError) {
      if (this.props.online) {
        this.props.networkError(networkError);
      }
    } else {
      this.props.resetNetworkError();
    }
    if (graphQLErrors) {
      this.props.graphqlError(graphQLErrors);
    } else {
      this.props.resetGraphqlError();
    }
  });

  client = new ApolloClient({
    link: ApolloLink.from([this.notifyError, this.WatchedMutationLink, authLink, httpLink]),
    cache: this.cache,
  });
  state = {
    authenticated: false,
    loginError: false,
  };
  async componentDidMount() {
    const auth0Client = await createAuth0Client({
      domain: AUTH_CONFIG.domain,
      clientId: AUTH_CONFIG.clientId,
      authorizationParams: {
        audience: AUTH_CONFIG.api_audience,
      },
    });
    const query = window.location.search;

    if (query.includes("code=") && query.includes("state=")) {
      await auth0Client.handleRedirectCallback();
    }

    const isAuthenticated = await auth0Client.isAuthenticated();

    if (isAuthenticated) {
      const token = await auth0Client.getTokenSilently();
      const claims = await auth0Client.getIdTokenClaims();
      const id_token = claims.__raw;
      window.localStorage.setItem("access_token", token);
      await this.client
        .mutate({
          mutation: AUTHENTICATE,
          variables: { idToken: id_token },
        })
      this.setState({ authenticated: true, auth0Client });
      if(!["print", "share"].includes(window.location.pathname.split("/").splice(1)[0])){
        this.props.push("/app");
      }
      return;
    } else if(!["print", "share"].includes(window.location.pathname.split("/").splice(1)[0])) {
      auth0Client.loginWithRedirect({
        authorizationParams: {
          redirect_uri: window.location.origin + "/callback",
        },
      });
    }
  }
  render() {
    const { online } = this.props;
    return (
      <ApolloProvider client={this.client}>
        <React.Fragment>
          <Switch>
            <Route
              path="/app"
              render={(props) => {
                return (
                  <Container
                    {...props}
                    online={online}
                    logout={() =>
                      this.state.auth0Client.logout({
                        logoutParams: {
                          returnTo: window.location.origin,
                        },
                      })
                    }
                  />
                );
              }}
            />
            <Route
              path="/callback"
              render={(props) => {
                return (
                  <>
                    <div>logging in</div>
                  </>
                );
              }}
            />
            <Route
              path="/print/computation/:organisationId/:computationId"
              render={(props) => (
                <PrintComputation computationId={props.match.params.computationId} organisationId={props.match.params.organisationId} />
              )}
            />
            <Route
              path="/print/encoded/computation/:organisationId/:encodedComputation"
              render={(props) => (
                <PrintEncodedComputation
                  encodedComputation={props.match.params.encodedComputation}
                  organisationId={props.match.params.organisationId}
                />
              )}
            />
            <Route
              path="/print/count/:organisationId/:countId"
              render={(props) => <PrintCount countId={props.match.params.countId} organisationId={props.match.params.organisationId} />}
            />
            <Route
              path="/print/super_count/:organisationId/:superCountId"
              render={(props) => (
                <PrintSuperCount superCountId={props.match.params.superCountId} organisationId={props.match.params.organisationId} />
              )}
            />
            <Route
              path="/share/computation/:organisationId/:computationId"
              render={(props) => (
                <ShareComputation computationId={props.match.params.computationId} organisationId={props.match.params.organisationId} />
              )}
            />
            <Route
              path="/share/encoded/computation/:organisationId/:encodedComputation"
              render={(props) => (
                <ShareEncodedComputation
                  encodedComputation={props.match.params.encodedComputation}
                  organisationId={props.match.params.organisationId}
                />
              )}
            />
            <Route
              path="/share/count/:organisationId/:countId"
              render={(props) => <ShareCount countId={props.match.params.countId} organisationId={props.match.params.organisationId} />}
            />
            <Route
              path="/"
              render={(props) => {
                return <div>Authenticating....</div>;
              }}
            />
            <Redirect to="/" />
          </Switch>
        </React.Fragment>
      </ApolloProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    push: (url) => {
      dispatch(push(url));
    },
    graphqlError: (error) => {
      dispatch(graphqlError(error));
    },
    networkError: (error) => {
      dispatch(networkError(error));
    },
    resetGraphqlError: () => {
      dispatch(resetGraphqlError());
    },
    resetNetworkError: () => {
      dispatch(resetNetworkError());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
